import script from "./TestAbDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TestAbDialog.vue?vue&type=script&setup=true&lang=js"

import "./TestAbDialog.vue?vue&type=style&index=0&id=3d6e5240&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6e5240"]])

export default __exports__